<template>
  <div>
    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>EDITAR MENSAGEM</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        />
      </div>
      <vs-divider class="mb-0" />

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <h4>{{ setting.name }}</h4>

          <div style="margin-top: 20px">
            <textarea
              class="vs-textarea text-area message-text-area"
              name="value"
              v-model="setting.value"
              v-validate="'required'"
              style="border: 1px"
              ref="wa-message"
              id="wa-message"
              rows="10"
            />
            <div v-if="setting.options" class="tags-wrapper">
              <ul>
                <li
                  v-for="(tag, index) in setting.options"
                  :key="`tag-${index}`"
                >
                  <vs-button
                    type="flat"
                    color="primary"
                    @click.stop="insertTagOnText(tag)"
                  >
                    {{tag}}
                  </vs-button>
                </li>
              </ul>
            </div>
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('value')"
            >{{ errors.first('value') }}</span
          >
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
          Salvar
        </vs-button>
        <vs-button
          type="border"
          color="danger"
          @click="isSidebarActiveLocal = false"
        >
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import request from '@/http/requests/messages'

export default {
  name: 'settings-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    setting: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
     insertTagOnText(tag) {
        const that = this
        let tArea = this.$refs['wa-message']

        if (!tag) {
          return
        }

        // get cursor's position:
        let startPos = tArea.selectionStart
        let endPos = tArea.selectionEnd
        let cursorPos = startPos
        let tmpStr = tArea.value || ''

        // insert:
          that.setting.value = `${tmpStr.substring(0, startPos)}{{${tag}}}` +
            `${tmpStr.substring(endPos, tmpStr.length)}`

          // move cursor:
          setTimeout(() => {
            cursorPos += that.campaign.message.length
            tArea.selectionStart = tArea.selectionEnd = cursorPos
			that.$refs['wa-message'].focus()
          }, 10)

        },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          request.update(this.setting).then(() => {
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'Alteração da mensagem foi realizada com sucesso.'
            })
          }).catch((error) => {
            console.log(error)
            this.$vs.notify({
              color: 'danger',
              title: 'Ocorreu um ao salvar a mensagem!',
              text: 'Sentimos muito, um erro ocorreu, por favor, nos contate para corrigir!'
            })
          }).finally(() => {
            this.$emit('closeSidebar');
            this.$emit('updateMessages');
          })
        }
      });
    }
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

@import "@/assets/scss/vuexy/extraComponents/tree.scss";


.height-auto {
  height: auto !important;
}

.message-text-area {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.tags-wrapper {
  background-color: #f8f8f8;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
  border-top: none !important;

  > ul > li {
    display: inline-block;
  }
}

.text-area {
  margin-top: 10px;
  background: #fff;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  resize: none !important;
}

.align-right {
  float: right;
}
</style>
